import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import store from './state/store';
import ProtectedRoute from './ProtectedRoute';
import ETLWorkflow from './workflows/ETLWorkflow';
import LoginPage from './Pages/loginPage/LoginPage';
import SignupPage from './Pages/signupPage/SignupPage';
import PasswordPage from './Pages/forgotPassword/PasswordPage';
import DashboardLayout from './Pages/landingPage/DashboardLayout';
import Connector from './Pages/landingPage/Connector';
import Reports from './Pages/landingPage/Reports';
import PipelinerunsMainpage from './Pages/PipelineRunsPage/PipelinerunsMainpage';
import PipelineRunDetails from './Pages/PipelineRunsPage/PipelineRunDetails';
import NaturalLanguageSearch from './Pages/NaturalLanguageSearchPage/NaturalLanguageSearch';
import LiveStreamingPage from './Pages/NaturalLanguageSearchPage/LiveStreamingPage';
import MainpageContent from './Pages/mainPage/components/MainpageContent';
import SidebarLayout from './Pages/projectDashboard/SidebarLayout';
import MyConnections from './Pages/connectionPage/MyConnections';
import CreateNewConnections from './Pages/connectionPage/CreateNewConnections';
import ConnectorMarketplace from './Pages/connectionPage/ConnectorMarketplace';
import CreatePipeline from './Pages/projectDashboard/CreatePipeline';
import 'react-toastify/dist/ReactToastify.css';
import ParentComponent from './workflows/Tabs/ParentComponent';
import ManageProfile from './Pages/landingPage/ManageProfile';
import ETLMapping from './workflows/Component/Mapping';
import MappingWrapper from './workflows/MappingWrapper';
import OAuthCallback from './apis/OAuthCallback';
import HubspotCallback from './Pages/connectionPage/HubspotCallback';
import { ThemeProvider } from './Context/ThemeContext';
import HelpdeskFloatingIcon from './components/HelpdeskFloatingIcon';
import AutoSignOut from './components/AutoSignOut';
import Settings from './Pages/SettingPage/Setting';
import Help from './Pages/HelpPage/Help';
import Documentation from './Pages/documentationPage/Documentation';
import ContactPage from './Pages/contactPage/ContactPage';
import { ToastContainer } from 'react-toastify';
import FreeTrial from './Pages/TrialPage/FreeTrial';
import TrialWarningBanner from './components/TrialWarningBanner';
import AdminUsers from './admin/pages/AdminUsers';
import AdminSetting from './admin/pages/AdminSetting';
import AdminAuditLog from './admin/pages/AdminAuditLog';
import AdminAnnoucement from './admin/pages/AdminNotification';
import AdminOrganizations from './admin/pages/AdminOrganizations';
import ChangePasswordPage from './Pages/changePasswordPage/ChangePassword';
import PricingPage from './Pages/pricingPage/PricingPage';
import PreMadeTemplates from './Pages/TemplatePage/PreMadeTemplates';
import TemplateDetail from './Pages/TemplatePage/TemplateDetail';
import TemplateSetup from './Pages/TemplatePage/TemplateSetup';
import TemplateConnections from './Pages/TemplatePage/TemplateConnections';

// const ConditionalHeader = () => {
//   const location = useLocation();

//   const protectedRoutes = [
//     '/userdashboard',
//     '/recentworkflows',
//     '/myconnections',
//     '/create-connections',
//     '/workflow',
//     '/manageprofile',
//     '/mappings',
//     '/settings',
//     '/help',
//     '/connector',
//     '/reports',
//     '/pipeline',
//   ];

//   const shouldShowHeader = protectedRoutes.some((route) =>
//     location.pathname.startsWith(route),
//   );

//   return shouldShowHeader ? <Header /> : null;
// };

function App() {
  return (
    <Provider store={store}>
      {' '}
      <GoogleOAuthProvider clientId="275346719774-6tfanmnhjr0p95dqp00nu1t0j5j7vpd1.apps.googleusercontent.com">
        <ThemeProvider>
          <Router>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <AutoSignOut />
            <TrialWarningBanner />
            {/* <ConditionalHeader /> */}

            <Routes>
              <Route path="/" element={<MainpageContent />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/trial" element={<FreeTrial />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgotpwd" element={<PasswordPage />} />
              <Route
                path="/userdashboard"
                element={<DashboardLayout />}
                />
              <Route
                path="/recentworkflows"
                element={<ProtectedRoute element={<SidebarLayout />} />}
              />
              <Route
                path="/myconnections"
                element={<MyConnections />}
              />
              <Route
                path="/connector-marketplace"
                element={<ProtectedRoute element={<ConnectorMarketplace />} />}
              />

              <Route
                path="/admin/user"
                element={<ProtectedRoute element={<AdminUsers />} />}
              />
              <Route
                path="/admin/annoucement"
                element={<ProtectedRoute element={<AdminAnnoucement />} />}
              />
              <Route
                path="/admin/setting"
                element={<ProtectedRoute element={<AdminSetting />} />}
              />

              <Route
                path="/admin/audit-log"
                element={<ProtectedRoute element={<AdminAuditLog />} />}
              />
              <Route
                path="/admin/organizations"
                element={<ProtectedRoute element={<AdminOrganizations />} />}
              />

              <Route
                path="/create-connections"
                element={<ProtectedRoute element={<CreateNewConnections />} />}
              />
              <Route
                path="/createpipeline"
                element={<ProtectedRoute element={<CreatePipeline />} />}
              />
              <Route path="/oauth/callback" element={<OAuthCallback />} />
              <Route path="/api/v1/jira/oauth" element={<OAuthCallback />} />
              <Route
                path="/workflow"
                element={<ProtectedRoute element={<ETLWorkflow />} />}
              />
              <Route
                path="/hubspot/oauth/callback"
                element={<HubspotCallback />}
              />
              <Route
                path="/connector"
                element={<ProtectedRoute element={<Connector />} />}
              />
              <Route
                path="/reports"
                element={<Reports />}
              />
              <Route
                path="/pipeline"
                element={<ProtectedRoute element={<PipelinerunsMainpage />} />}
              />
              <Route
                path="/pipeline/:runId"
                element={<ProtectedRoute element={<PipelineRunDetails />} />}
              />
              <Route
                path="/natural-language-search"
                element={<ProtectedRoute element={<NaturalLanguageSearch />} />}
              />
              <Route
                path="/nlp-live-streaming"
                element={<ProtectedRoute element={<LiveStreamingPage />} />}
              />
              
              <Route
                path="/pre-made-templates"
                element={<ProtectedRoute element={<PreMadeTemplates />} />}
              />
              <Route
                path="/pre-made-templates/:templateId"
                element={<ProtectedRoute element={<TemplateDetail />} />}
              />
              <Route
                path="/pre-made-templates/setup"
                element={<ProtectedRoute element={<TemplateSetup />} />}
              />
              <Route
                path="/pre-made-templates/setup/connections"
                element={<ProtectedRoute element={<TemplateConnections />} />}
              />
              <Route
                path="/parentworkflow/:workflowName"
                element={<ParentComponent />}
              />
              <Route
                path="/manageprofile"
                element={<ProtectedRoute element={<ManageProfile />} />}
              />
              <Route
                path="/mappings"
                element={<ETLMapping open={true} onClose={() => {}} />}
              />
              <Route
                path="/parentworkflow/:workflowName/mapping"
                element={<ProtectedRoute element={<MappingWrapper />} />}
              />
              <Route
                path="/settings"
                element={<ProtectedRoute element={<Settings />} />}
              />
              <Route
                path="/help"
                element={<Help />}
              />
              <Route path="/documentation" element={<Documentation />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/pricing" element={<PricingPage />} />
            </Routes>

            <HelpdeskFloatingIcon />
          </Router>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </Provider>
  );
}

export default App;
